export default __webpack_public_path__ + "static/media/icon1.4464a5af.svg";